<template>
  <div>
    <header-title :Title="'我的工具'"></header-title>
    <div>
      <el-card style="border-radius: 0.25rem">
        <div class="flex-between">
          <div class="tui-tabs">
            <div
              class="tui-tabsItem"
              @click="onClickTabList(index)"
              :class="currentIndex == index ? 'tui-active' : ''"
              v-for="(item, index) in tabList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <el-button
            v-if="userInfo.UserIdentity.indexOf('2') != -1"
            type="primary"
            round
            style="background: #32c5ff; border: 1px solid #32c5ff"
            @click="onClickMyMake"
            >我的预约</el-button
          >
        </div>
        <!-- 列表样式 -->
        <template>
          <!-- 场所类型 -->
          <div class="tui-placeType" style="padding: 0.375rem 0 0 0">
            <div class="flex-items">
              <div class="title">场所类型</div>
              <div class="flex-items" style="flex-wrap: wrap">
                <div
                  class="tui-placeTypeItem"
                  :class="placeIndex == index ? 'tui-placeTypeItemActive' : ''"
                  v-for="(item, index) in showHandleList"
                  :key="index"
                  @click="onClickPlaceType(index)"
                >
                  {{ item.Name }}
                </div>
              </div>
            </div>
            <div
              class="show-more"
              v-if="this.SourceTypeList.length > 10"
              @click="showAll = !showAll"
            >
              {{ word }}
              <i
                :class="[showAll ? 'el-icon-arrow-down' : 'el-icon-arrow-up']"
              ></i>
            </div>
          </div>
          <!-- 区域 -->
          <div class="tui-placeType" style="padding: 0">
            <div class="flex-items">
              <div class="title">区 域</div>
              <div class="flex-items" style="flex-wrap: wrap">
                <div
                  class="tui-placeTypeItem"
                  :class="cityIndex == index ? 'tui-placeTypeItemActive' : ''"
                  v-for="(item, index) in showHandleListCity"
                  :key="index"
                  @click="onClickCity(index)"
                >
                  {{ item.Name }}
                </div>
              </div>
            </div>
            <div
              class="show-more"
              v-if="this.codeList.length > 10"
              @click="showCityAll = !showCityAll"
            >
              {{ wordCity }}
              <i
                :class="[
                  showCityAll ? 'el-icon-arrow-down' : 'el-icon-arrow-up',
                ]"
              ></i>
            </div>
          </div>
          <div class="tui-placeType" style="padding: 0">
            <div class="flex-items">
              <div class="title">喜欢数量排序</div>
              <div class="flex-items" style="flex-wrap: wrap">
                <div
                  class="tui-placeTypeItem"
                  :class="
                    likeListIndex == index ? 'tui-placeTypeItemActive' : ''
                  "
                  v-for="(item, index) in likeListData"
                  :key="index"
                  @click="onClickLikeButton(index)"
                >
                  {{ item.Name }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex-items">
            <div class="flex-items tui-search" v-if="currentIndex == 1">
              <div>搜索：</div>
              <el-input
                style="width: 3.75rem"
                placeholder="请输入关键字"
                v-model="Name"
                @input="GetSourceInfoByPage"
              ></el-input>
            </div>
            <div
              class="flex-items tui-search m-l"
              v-show="
                classList.length > 1 && userInfo.UserIdentity.indexOf('2') != -1
              "
            >
              <div>班级：</div>
              <el-select
                v-model="ClassId"
                placeholder="请选择班级"
                @change="onChangeClassList"
                style="width: 3.75rem"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.ClassId"
                  :label="item.GradeName + '' + item.ClassName"
                  :value="item.ClassId"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </template>
      </el-card>
      <!-- 列表内容 -->
      <el-card style="border-radius: 0.25rem; margin-top: 0.375rem">
        <template v-if="currentIndex == 1">
          <div class="tui-list">
            <div
              class="tui-listItem"
              @click.stop="onClickDetail(item)"
              v-for="(item, index) in tableData"
              :key="index"
            >
              <div class="tui-listItemImg">
                <el-image
                  style="width: 100%; height: 100%; border-radius: 0.25rem"
                  :src="item.Img"
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <img
                      style="width: 100%; height: 100%"
                      src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818160410_7541.png"
                      alt=""
                    />
                  </div>
                </el-image>
              </div>
              <div class="tui-listRight">
                <div class="tui-coolRight">
                  <div class="tui-coolTitle">{{ item.Name }}</div>
                  <div class="flex-items">
                    <div
                      v-if="userInfo.UserIdentity.indexOf('2') != -1"
                      class="tui-coolBtn"
                      :style="{
                        background:
                          item.IsCancelMake == 0 ? '#27ABF7' : '#F6F6F6',
                        color: item.IsCancelMake == 0 ? '#fff' : '#333',
                      }"
                      @click.stop="
                        onClickCreateClock(
                          item.Name,
                          item.SourceId,
                          item.Img,
                          item.IsMake,
                          item.IsCancelMake,
                          item.Detail,
                          item.Address,
                          item.BusinessHours
                        )
                      "
                    >
                      <i class="el-icon-location-outline"></i>
                      <div>
                        {{ item.IsCancelMake == 0 ? "去打卡" : "取消打卡" }}
                      </div>
                    </div>
                    <div
                      style="margin-left: 20px"
                      class="tui-coolBtn"
                      :style="{
                        background:
                          item.IsCancelMake == 0 ? '#27ABF7' : '#F6F6F6',
                        color: item.IsCancelMake == 0 ? '#fff' : '#333',
                      }"
                      @click.stop="onClickEvealute(item.SourceId)"
                    >
                      <i class="el-icon-location-outline"></i>
                      <div>查看评价记录</div>
                    </div>
                  </div>
                </div>
                <div class="tui-desc">
                  <img
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150154_1171.png"
                    alt=""
                  />
                  <div>场馆地址：{{ item.Address }}</div>
                </div>
                <div class="tui-desc">
                  <img
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150545_4129.png"
                    alt=""
                  />
                  <div>场馆描述：{{ item.Detail }}</div>
                </div>
                <div class="tui-desc">
                  <img
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150608_2045.png"
                    alt=""
                  />
                  <div>开放时间：{{ item.BusinessHours }}</div>
                </div>
                <div class="tui-desc">
                  <img
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150154_1171.png"
                    alt=""
                  />
                  <div>想去的数量：{{ item.FavoriteNum }}</div>
                </div>
              </div>
            </div>
            <el-empty
              v-if="tableData.length == 0"
              description="暂无数据"
            ></el-empty>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="PageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="text-align: center; padding: 20px 0 0 0"
          >
          </el-pagination>
        </template>
        <!-- 地图 -->
        <template v-if="currentIndex == 0">
          <div class="map-wrap">
            <div id="container"></div>

            <!-- <el-input
              id="tipinput"
              placeholder="请输入内容"
              style="
                position: absolute;
                top: 0.25rem;
                left: 0.25rem;
                width: 6.15rem;
                height: 0.5rem;
                background: #ffffff;
                box-shadow: 0px 1px 12px 0px rgba(119, 119, 119, 0.2);
                border-radius: 10px;
                border: 1px solid #eeeeee;
              "
            ></el-input> -->
          </div>
        </template>
      </el-card>
    </div>
    <!-- 去打卡 -->
    <el-dialog
      title="教师场馆打卡"
      :visible.sync="dialogVisible"
      width="30%"
      custom-class="tui-dialog"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-position="left"
          label-width="100px"
        >
          <el-form-item label="场馆名称：">
            <div class="tui-textFont">{{ form.Name }}</div>
          </el-form-item>
          <el-form-item label="场馆地址：">
            <div class="tui-textFont">{{ form.Address }}</div>
          </el-form-item>
          <el-form-item label="选择班级：">
            <el-select
              v-model="form.ClassId"
              placeholder="请选择"
              style="width: 3.75rem"
              @change="onChageCreateClass"
            >
              <el-option
                v-for="item in classList"
                :key="item.ClassId"
                :label="item.GradeName + '' + item.ClassName"
                :value="item.ClassId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择幼儿：">
            <div class="flex-items">
              <el-select
                v-model="form.StudentIds"
                placeholder="请选择幼儿名称"
                style="width: 3.75rem"
                multiple
              >
                <el-option
                  v-for="item in CustomerInfosList"
                  :key="item.CustomerId"
                  :label="item.CustomerName"
                  :value="item.CustomerId"
                >
                </el-option>
              </el-select>
              <el-button
                type="primary"
                round
                v-if="CustomerInfosList.length != 0"
                style="
                  background: #32c5ff;
                  border: 1px solid #32c5ff;
                  margin-left: 20px;
                "
                @click="onClickAllStudent"
                >全选</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="带队者：">
            <el-input
              v-model="form.TeamLeader"
              style="width: 3.75rem"
              placeholder="请输入带队者姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="预约时间：">
            <el-date-picker
              style="width: 3.75rem"
              v-model="form.Time"
              type="datetimerange"
              range-separator="-"
              start-placeholder="开始日期"
              :picker-options="pickerOptions1"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          style="background: #32c5ff; border: 1px solid #32c5ff"
          round
          @click="onSubmitAddClock"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 预约详情 -->
    <el-dialog
      title="列表详情"
      :visible.sync="makerDialogVisible"
      width="50%"
      custom-class="tui-dialog"
    >
      <div>
        <div class="tui-tabs">
          <div
            class="tui-tabsItem"
            @click="onClickLike(index)"
            :class="likeIndex == index ? 'tui-active' : ''"
            v-for="(item, index) in likeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div style="padding-top: 30px">
          <el-table
            :data="makeTableData"
            style="width: 100%"
            :header-cell-style="{ color: '#000' }"
          >
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="likeIndex == 0"
              prop="TeamLeader"
              label="带队者"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-if="likeIndex == 1"
              prop="StudentName"
              label="名称"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="ClassName" label="班级" align="center">
            </el-table-column>
            <el-table-column
              label="参与学生"
              width="100"
              align="center"
              v-if="likeIndex == 0"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="getData(scope.row)"
                >
                  <el-button
                    icon="el-icon-search"
                    slot="reference"
                    circle
                  ></el-button>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              v-if="likeIndex == 0"
              prop="Status"
              label="状态"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column
              :prop="likeIndex == 0 ? 'Time' : 'CreateTime'"
              label="时间"
              align="center"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChangeMake"
            @current-change="handleCurrentChangeMake"
            :current-page="PageIndexMake"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="PageSizeMake"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalMake"
            style="text-align: center; padding: 20px 0 0 0"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="makerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="makerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 我的预约详情 -->
    <el-dialog
      title="我的预约列表"
      :visible.sync="dialogVisibleMake"
      width="50%"
      custom-class="tui-dialog"
    >
      <div>
        <div style="padding-top: 30px">
          <el-table
            :data="TableDataMake"
            style="width: 100%"
            :header-cell-style="{ color: '#000' }"
          >
            <el-table-column label="序号" width="50" align="center">
              <template slot-scope="scope">
                {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="SourceName"
              label="场馆名称"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="TeamLeader"
              label="带队者"
              width="100"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="ClassName" label="班级" align="center">
            </el-table-column>
            <el-table-column label="参与学生" width="100" align="center">
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="getData(scope.row)"
                >
                  <el-button
                    icon="el-icon-search"
                    slot="reference"
                    circle
                  ></el-button>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column
              prop="Status"
              label="状态"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="Time" label="时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.IsCancelMake == 1"
                  @click="cancelMakeConfirm(scope.row)"
                  >取消预约</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChangeMyMake"
            @current-change="handleCurrentChangeMyMake"
            :current-page="PageMake"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="PageSizeMyMake"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalMyMake"
            style="text-align: center; padding: 20px 0 0 0"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMake = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleMake = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerTitle from "@/components/headerTitle/headerTitle.vue";
import {
  GetSourceTypeList,
  GetSourceInfoByPage,
  GetClassByCustomerId,
  GetRegionList,
  MakeHx_SourceInfo,
  CancelMakeHx_Source,
  GetMakeDetailBySource,
  GetFavoriteBySource,
  GetMyMakeDetail,
} from "../../api/api";
import { getMonthStartDate, getMonthEndDate } from "../../../util/otherRenders";

var devInfo = null;

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      tabList: [
        {
          name: "地图样式",
          id: 0,
        },
        {
          name: "列表样式",
          id: 1,
        },
      ],
      likeIndex: 0,
      likeList: [
        {
          name: "打卡列表",
          id: 0,
        },
        {
          name: "喜欢列表",
          id: 1,
        },
      ],

      currentIndex: 1,
      placeIndex: 0,
      cityIndex: 0,
      dialogVisible: false,
      dialogVisibleMake: false,
      form: {
        ClassId: "",
        Time: "",
        StudentIds: [],
        TeamLeader: "",
        TeamLeaderUserId: 0,
        SourceId: 0,
      },
      options: [
        {
          label: "测试",
          value: "1",
        },
      ],
      value: "",
      SourceTypeList: [],
      Name: "",
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      classList: [],
      ClassId: "",
      tableData: [],
      codeList: [],
      mapData: [],
      zoomPageSize: 500,
      showAll: false,
      showCityAll: false,
      CustomerInfosList: [],
      marker: "noData",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      btnText: "全选",
      PageIndexMake: 1,
      PageSizeMake: 10,
      totalMake: 0,
      makerDialogVisible: false,
      makeTableData: [],
      clockSourceId: 0,
      PageMake: 1,
      PageSizeMyMake: 10,
      totalMyMake: 0,
      TableDataMake: [],
      likeListData: [
        {
          Name: "默认排序",
          Id: "0",
        },
        {
          Name: "从大到小",
          Id: "1",
        },
      ],
      likeListIndex: 0,
    };
  },
  mounted() {
    // this.initMap();
    window._AMapSecurityConfig = {
      serviceHost: "http://mgdv3.api.shengxuemap.cn/_AMapService",
    };
  },
  watch: {
    $route(to, from) {
      //console.log(to, from, "route");
      // 对路由变化作出响应...
    },
  },
  async created() {
    if (this.$route.query.Index) {
      //console.log("索引");
      this.placeIndex = this.$route.query.Index;
    }
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));

    await this.GetSourceTypeList();
    await this.GetRegionList();
    // if (this.currentIndex == 1) {
    //   await this.GetClassByCustomerId();
    //   await this.GetSourceInfoByPage();
    // }
    await this.GetClassByCustomerId();
    await this.GetSourceInfoByPage();
  },
  computed: {
    word() {
      if (this.showAll == false) {
        //对⽂字进⾏处理
        return "展开";
      } else {
        return "收起";
      }
    },
    showHandleListCity() {
      if (this.showCityAll == false) {
        //收起状态-显示“展示”
        var showList = []; //定义⼀个空数组
        if (this.codeList.length > 10) {
          //控制显⽰前三个
          for (var i = 0; i < 10; i++) {
            showList.push(this.codeList[i]); //将数组的前3条存放到showList数组中
          }
        } else {
          showList = this.codeList; //个数足够显示，不需要再截取
        }
        return showList; //返回当前数组
      } else {
        // 展开状态-显示“收起”
        return this.codeList;
      }
    },
    wordCity() {
      if (this.showCityAll == false) {
        //对⽂字进⾏处理
        return "展开";
      } else {
        return "收起";
      }
    },
    showHandleList() {
      if (this.showAll == false) {
        //收起状态-显示“展示”
        var showList = []; //定义⼀个空数组
        if (this.SourceTypeList.length > 10) {
          //控制显⽰前三个
          for (var i = 0; i < 10; i++) {
            showList.push(this.SourceTypeList[i]); //将数组的前3条存放到showList数组中
          }
        } else {
          showList = this.SourceTypeList; //个数足够显示，不需要再截取
        }
        return showList; //返回当前数组
      } else {
        // 展开状态-显示“收起”
        return this.SourceTypeList;
      }
    },
  },
  methods: {
    // 查看评价记录
    onClickEvealute(SourceId) {
      this.$router.push({
        path: "/tool-Map/comment",
        query: {
          SourceId: SourceId,
        },
      });
    },
    onClickLikeButton(index) {
      this.likeListIndex = index;
      this.GetSourceInfoByPage();
    },
    async cancelMakeConfirm(item) {
      if (item.IsCancelMake == 1) {
        this.$confirm("是否取消预约打卡, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let res = await CancelMakeHx_Source({ Id: item.Id });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "取消预约打卡成功",
            });

            this.GetMyMakeDetail();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "不能取消预约",
        });
      }
    },
    // 我的预约
    async onClickMyMake() {
      this.GetMyMakeDetail();
      this.dialogVisibleMake = true;
    },
    async GetMyMakeDetail() {
      console.log(this.ClassId == "" ? 0 : this.ClassId, "this.ClassId");
      let res = await GetMyMakeDetail({
        ClassId: this.ClassId == "" ? 0 : this.ClassId,
        PageIndex: this.PageMake,
        PageSize: this.PageSizeMyMake,
      });
      if (res.data.success) {
        this.TableDataMake = res.data.response.data;
        this.totalMyMake = res.data.response.dataCount;
      } else {
        this.TableDataMake = [];
        this.totalMyMake = 0;
      }
    },
    onClickLike(e) {
      this.likeIndex = e;
      this.PageIndexMake = 1;
      if (this.likeIndex == 0) {
        this.GetMakeDetailBySource();
      } else {
        this.GetFavoriteBySource();
      }
    },
    async GetFavoriteBySource() {
      let res = await GetFavoriteBySource({
        Id: this.clockSourceId,
        PageIndex: this.PageIndexMake,
        PageSize: this.PageSizeMake,
      });
      if (res.data.success) {
        this.makeTableData = res.data.response.data;
        this.totalMake = res.data.response.dataCount;
      } else {
        this.makeTableData = [];
      }
    },
    getData(val) {
      var content = val.Students.join(",");
      return content;
    },
    handleSizeChangeMake(e) {
      this.PageSizeMake = e;
      if (this.likeIndex == 0) {
        this.GetMakeDetailBySource();
      } else {
        this.GetFavoriteBySource();
      }
    },
    //分页
    handleCurrentChangeMake(val) {
      this.PageIndexMake = val;
      if (this.likeIndex == 0) {
        this.GetMakeDetailBySource();
      } else {
        this.GetFavoriteBySource();
      }
    },
    handleSizeChangeMyMake(e) {
      this.PageSizeMyMake = e;
      this.GetMyMakeDetail();
    },
    //分页
    handleCurrentChangeMyMake(val) {
      this.PageMake = val;
      this.GetMyMakeDetail();
    },
    // 全选
    onClickAllStudent() {
      console.log(this.CustomerInfosList);
      this.form.StudentIds = this.CustomerInfosList.map((cc) => cc.CustomerId);
    },
    onChangeClassList(e) {
      this.ClassId = e;
      this.GetSourceInfoByPage();
    },
    // 地图列表
    async GetSourceInfoByPage(zoomPageSize = 10000) {
      let res = await GetSourceInfoByPage({
        AreaCode: this.codeList[this.cityIndex].Code,
        SourceTypeId: this.SourceTypeList[this.placeIndex].Id,
        SchoolId: this.userInfo.SchoolId,
        ClassId: this.ClassId == "" ? 0 : this.ClassId,
        PageIndex: this.PageIndex,
        PageSize: this.currentIndex == 0 ? zoomPageSize : this.PageSize,
        Name: this.Name,
        FavoriteSort: this.likeList[this.likeListIndex].id,
        IsSociety: 0,
      });
      if (res.data.success) {
        if (this.currentIndex == 1) {
          this.tableData = res.data.response.data;
        } else {
          //console.log(res.data.response.data, "res.response.data");
          this.mapData = res.data.response.data;
        }
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
        if (this.currentIndex == 0) {
          this.mapData = [];
        }
      }
    },
    async getNowTime() {
      this.form.Time.push(getMonthStartDate());
      this.form.Time.push(getMonthEndDate());
    },
    clockResetData() {
      this.form = {
        ClassId: "",
        Time: "",
        StudentIds: [],
        TeamLeader: "",
        TeamLeaderUserId: 0,
        SourceId: 0,
      };
    },
    // 去打卡
    async onSubmitAddClock() {
      if (
        this.form.ClassId != "" &&
        this.form.StudentIds.length != 0 &&
        this.form.TeamLeader != "" &&
        this.form.Time != ""
      ) {
        //console.log(this.form);
        let res = await MakeHx_SourceInfo({
          sourceId: this.form.SourceId,
          classId: this.form.ClassId == "" ? 0 : this.form.ClassId,
          studentIds: this.form.StudentIds,
          teamLeader: this.form.TeamLeader,
          teamLeaderUserId: this.form.TeamLeaderUserId,
          startTime: this.form.Time[0],
          endTime: this.form.Time[1],
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "预约打卡成功",
          });
          this.clockResetData();
          if (this.currentIndex == 0) {
            await this.GetSourceInfoByPage();
            await this.initMap();
          } else {
            this.GetSourceInfoByPage();
          }

          this.dialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "请填写所有选项",
        });
      }
    },
    // 班级选择幼儿
    onChageCreateClass(e) {
      var arr = this.classList.find((item) => item.ClassId == e);
      this.CustomerInfosList = arr.CustomerInfosList;
      //console.log(arr);
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.GetSourceInfoByPage();
    },
    //分页
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetSourceInfoByPage();
    },
    // 省市区
    async GetRegionList() {
      let res = await GetRegionList({ Code: 310100 });
      if (res.data.success) {
        if (this.currentIndex == 1) {
          res.data.response.unshift({
            Id: "",
            Name: "全部",
            Code: "",
          });
        }
        this.codeList = res.data.response;
      }
    },
    // 获取班级
    async GetClassByCustomerId() {
      let res = await GetClassByCustomerId({
        Id: 0,
        IsTeacher: this.userInfo.UserIdentity.indexOf("2") != -1 ? 1 : 0,
      });
      if (res.data.success) {
        if (res.data.response.length != 0) {
          this.ClassId = res.data.response[0].ClassId;
        }
        this.classList = res.data.response;
      }
    },
    // 获取资源类型
    async GetSourceTypeList() {
      let res = await GetSourceTypeList();
      if (res.data.success) {
        res.data.response.unshift({
          Id: 0,
          Name: "全部",
        });
        this.SourceTypeList = res.data.response;
      }
    },
    initMap() {
      if (this.currentIndex == 0) {
        var url = `https://webapi.amap.com/maps?v=1.4.15&key=e02a4463fd31ffab2b9564d2e958f6da&callback=onLoad&plugin=AMap.Geocoder,AMap.DistrictSearch,AMap.MassMarks`;
        var zoom = 0;
        //  创建一个script dom元素
        var jsapi = document.createElement("script");

        //  设定script标签属性
        jsapi.charset = "utf-8";
        jsapi.src = url;
        // 将api文件引入到页面中，加载完毕以后就会回调函数 onLoad
        document.head.appendChild(jsapi);
        window.onLoad = () => {
          // var marker;
          // 保证高德地图加载完毕
          var map = new AMap.Map("container", {
            center: [121.472603, 31.229572], //中心点坐标
            viewMode: "3D", //使用3D视图
            zooms: [11, 17],
          });
          let massMarks;
          //实例化地图

          const styleObjectArr = [
            {
              url: "https://webapi.amap.com/images/mass/mass0.png", // 图标地址
              size: new AMap.Size(11, 11), // 图标大小
              anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
            },
            {
              url: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-8/2022-8-29/20220829093045_2285.png", //"https://webapi.amap.com/images/mass/mass1.png", // 图标地址
              size: new AMap.Size(11, 11), // 图标大小
              anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
            },
          ];

          const markerList = this.mapData.map((item, index) => ({
            lnglat: [Number(item.Long), Number(item.Lat)],
            name: item.Name,
            id: item.SourceId,
            style: item.IsInit == 0 ? 0 : 1,
          }));
          massMarks = new AMap.MassMarks(markerList, {
            zIndex: 500, // 海量点图层叠加的顺序
            zooms: [3, 14], // 在指定地图缩放级别范围内展示海量点图层
            style: styleObjectArr, // 设置样式数组
          });
          console.log(massMarks, "massMarks");
          massMarks.setMap(map);
          var markerData = this.mapData.map((cc) => {
            return {
              position: new AMap.LngLat(Number(cc.Long), Number(cc.Lat)), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: cc.Name,
              offset: new AMap.Pixel(-100, -100),
              content: `   <div class="tui-maker">
                <div style="position: relative" class="flex-items">
                 <div class="tui-makerTitle">
                  <p style="white-space: nowrap;">${cc.Name}</p>
                  </div>
                </div>
                <div style="padding-top: 0.125rem;">
                  <img
                    alt=""
                    src="${
                      cc.IsMake != 0
                        ? "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-12/20220812103511_8132.png"
                        : cc.IsFavorite != 0
                        ? "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818194643_7858.png"
                        : "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805164233_9457.png"
                    }"
                  />
                </div>
              </div>`,
              objs: cc,
            };
          });
          // let marker;
          map.on("zoomend", () => {
            // var marker = null;
            // 监听地图缩放结束后的等级
            zoom = map.getZoom();
            console.log(zoom);
            if (zoom >= 14) {
              if (this.marker == "noData") {
                var arr = [];
                markerData.forEach((item) => {
                  var marker = new AMap.Marker({
                    content: item.content,
                    position: item.position,
                    title: item.title,
                    offset: item.offset,
                  });
                  this.marker = "isData";

                  arr.push(
                    Object.assign(item, {
                      mapId: marker._amap_id,
                      isCreateContent: false,
                    })
                  );
                  marker.setMap(map);

                  // 鼠标点击marker弹出自定义的信息窗体
                  AMap.event.addListener(marker, "click", (e) => {
                    console.log(e, "点击");
                    markerClick(arr, marker);
                  });
                });
              }
            } else {
              //console.log("小");
              if (zoom <= 13) {
                var marker = null;
                if (this.marker == "isData") {
                  // map.remove(marker);
                  // marker.setMap(null);
                  var overlays = map.getAllOverlays();

                  // var position = overlays[0].getPosition();
                  map.remove(overlays);
                  this.marker = "noData";
                  // map.clearMap();
                  // //console.log(position, overlays);
                }
              }
            }
          });
          // 添加点标记

          //点击标记 获取所点击标记的信息以及窗体要展示的数据，创建信息窗体
          function markerClick(arr, marker) {
            //console.log(marker, "marker._amap_id");
            var arrNew = arr.filter((x) => x.mapId == marker._amap_id);
            //console.log(arrNew, "arrNew");

            devInfo = arrNew && arrNew[0];

            if (!arrNew[0].isCreateContent) {
              var infoWindow = createInfoWindow(arrNew[0].objs);
              openInfoWindow(infoWindow, marker);
              arrNew[0].isCreateContent = true;
            } else {
              arrNew[0].isCreateContent = false;
              closeInfoWindow();
            }
          }
          //构建自定义窗体
          function createInfoWindow(val) {
            var infoWindowData = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: getContent(val),
              offset: new AMap.Pixel(16, -45),
            });
            return infoWindowData;
          }
          // 处理窗体内容
          function getContent(val) {
            let i = JSON.stringify(val).replace(/\"/g, "'");
            console.log(typeof i, "i");
            var userInfo = JSON.parse(window.localStorage.getItem("user"));
            var content = "";
            if (userInfo.UserIdentity.indexOf("2") != -1) {
              content = `
            <div class="tui-createCont">
        <div class="flex-items" style="padding: 0.25rem">
          <div class="tui-createImg">
            <img src="${
              val.Img
                ? val.Img
                : "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818160410_7541.png"
            }" alt="">
             
          </div>
          <div style="padding-left: 0.2rem">
            <div class="tui-createTitle">${val.Name}</div>
            <div class="tui-addMapBtn" onclick="onClickCreateClock(\'${
              val.Name
            }\',\'${val.SourceId}\',\'${val.Img}\',\'${val.IsMake}\',\'${
                val.IsCancelMake
              }\',\'${val.Detail}\',\'${val.BusinessHours}\',\'${
                val.Address
              }\')" >
              <i class="el-icon-location-outline" style="color: #fff"></i>
              <div>${val.IsCancelMake == 0 ? "去打卡" : "取消打卡"}</div>
            </div>
          </div>
        </div>
        <div style="padding: 0 0.25rem 0.25rem 0.25rem">
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150154_1171.png"
              alt=""
            />
            <div style="font-size: 0.15rem">
              场馆地址：${val.Address}
            </div>
          </div>
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150545_4129.png"
              alt=""
            />
            <div style="font-size: 0.15rem">
              场馆描述：${val.Detail}
            </div>
          </div>
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150608_2045.png"
              alt=""
            />
            <div style="font-size: 0.15rem" >
              开放时间：${val.BusinessHours}
            </div>
          </div>
        </div>
      </div>
        `;
            } else {
              content = `
            <div class="tui-createCont">
        <div class="flex-items" style="padding: 0.25rem">
          <div class="tui-createImg">
            <img src="${
              val.Img
                ? val.Img
                : "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-18/20220818160410_7541.png"
            }" alt="">
             
          </div>
          <div style="padding-left: 0.2rem">
            <div class="tui-createTitle">${val.Name}</div>
            <div class="tui-addMapBtn" onclick="onClickAddClock('${
              val.SourceId
            }')" >
              
              <div>列表详情</div>
            </div>
          </div>
        </div>
        <div style="padding: 0 0.25rem 0.25rem 0.25rem">
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150154_1171.png"
              alt=""
            />
            <div style="font-size: 0.15rem">
              场馆地址：${val.Address}
            </div>
          </div>
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150545_4129.png"
              alt=""
            />
            <div style="font-size: 0.15rem">
              场馆描述：${val.Detail}
            </div>
          </div>
          <div class="tui-desc">
            <img
              src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-5/20220805150608_2045.png"
              alt=""
            />
            <div style="font-size: 0.15rem" >
              开放时间：${val.BusinessHours}
            </div>
          </div>
        </div>
      </div>
        `;
            }

            return content;
          }
          // 打开窗体
          function openInfoWindow(infoWindow, marker) {
            infoWindow.open(map, marker.getPosition());
          }
          // 关闭窗体
          function closeInfoWindow() {
            map.clearInfoWindow();
          }
          window.onClickCreateClock = (
            Name,
            SourceId,
            Img,
            IsMake,
            IsCancelMake,
            Detail,
            Address,
            BusinessHours
          ) => {
            this.onClickCreateClock(
              Name,
              SourceId,
              Img,
              IsMake,
              IsCancelMake,
              Detail,
              Address,
              BusinessHours
            );
          };
          window.onClickAddClock = (val) => {
            this.onClickAddClock(val);
          };
        };
      }
    },
    // 场所类型点击
    async onClickPlaceType(index) {
      this.placeIndex = index;
      this.PageIndex = 1;
      if (this.currentIndex == 1) {
        this.GetSourceInfoByPage();
      } else {
        await this.GetSourceInfoByPage();

        await this.initMap();
      }
    },
    // 区域点击
    async onClickCity(index) {
      this.cityIndex = index;
      this.PageIndex = 1;
      if (this.currentIndex == 1) {
        this.GetSourceInfoByPage();
      } else {
        await this.GetSourceInfoByPage();

        await this.initMap();
      }
    },
    async onClickTabList(index) {
      this.currentIndex = index;
      this.GetClassByCustomerId();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await this.GetSourceTypeList();
      await this.GetRegionList();
      if (this.currentIndex == 0) {
        this.placeIndex = 0;
        this.cityIndex = 0;
        await this.GetSourceInfoByPage();
        await this.initMap();
        loading.close();
      } else {
        location.reload();
        loading.close();
      }
    },
    // 园长查看打卡列表
    async onClickAddClock(SourceId) {
      this.clockSourceId = SourceId;
      this.likeIndex = 0;
      this.GetMakeDetailBySource();
      this.makerDialogVisible = true;
    },
    async GetMakeDetailBySource() {
      let res = await GetMakeDetailBySource({
        Id: this.clockSourceId,
        PageIndex: this.PageIndexMake,
        PageSize: this.PageSizeMake,
      });
      if (res.data.success) {
        this.makeTableData = res.data.response.data;
        this.totalMake = res.data.response.dataCount;
      } else {
        this.makeTableData = [];
      }
    },
    // 教师馆打卡
    async onClickCreateClock(
      Name,
      SourceId,
      Img,
      IsMake,
      IsCancelMake,
      Detail,
      BusinessHours,
      Address
    ) {
      //console.log(item, "sssssss");
      if (IsCancelMake == 0) {
        this.form = {
          ClassId: "",
          Time: "",
          StudentIds: [],
          TeamLeader: "",
          TeamLeaderUserId: 0,
          Name: Name,
          Address: Address,
          SourceId: SourceId,
        };
        // this.getNowTime();
        this.dialogVisible = true;
      } else {
        // 取消打卡
        this.$confirm("是否取消预约打卡, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let res = await CancelMakeHx_Source({ Id: SourceId });
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "取消预约打卡成功",
              });

              if (this.currentIndex == 0) {
                await this.GetSourceInfoByPage();
                await this.initMap();
              } else {
                this.GetSourceInfoByPage();
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
          .catch(() => {});
      }
    },
    // 进入场馆详情
    onClickDetail(item) {
      //console.log(item);
      this.$router.push({
        path: "/tool-Map/detail",
        query: {
          t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
          SourceId: item.SourceId,
          ClassId: this.ClassId,
        },
      });
    },
  },
};
</script>
<style lang="less">
.amap-marker-content {
  white-space: normal !important;
}

.show-more {
  display: flex;
  cursor: pointer;
  flex-shrink: 0;
  padding-bottom: 0.25rem;
  color: #1890ff;
}

.map-wrap {
  position: relative;
}

.m-l {
  margin-left: 0.25rem;
}

.el-dialog__header {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808145755_3530.png")
    no-repeat;
  padding: 30px 20px 30px;
  background-size: 100% 100%;
}

.tui-dialog {
  border-radius: 0.25rem;
  overflow: hidden;
}

.tui-textFont {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.tui-createCont {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808111718_0290.png")
    no-repeat;
  background-size: 100% 100%;
  width: 3.475rem;

  .tui-createImg {
    width: 1.525rem;
    height: 0.8875rem;
    border-radius: 0.25rem;
    // background: red;
    display: flex;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tui-createTitle {
    font-size: 0.175rem;
    color: #333;
    font-weight: 600;
    padding-bottom: 0.1875rem;
  }

  .tui-addMapBtn {
    width: 1.25rem;
    height: 0.4rem;
    background: #27abf7;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-left: 0.25rem;
    cursor: pointer;

    img {
      width: 0.2rem;
      height: 0.2rem;
    }

    div {
      color: #fff;
      font-size: 0.2rem;
      padding-left: 0.0625rem;
    }
  }
}

#container {
  width: 100%;
  height: 8.25rem;
}

.tui-maker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tui-makerTitle {
    height: 0.5rem;
    background: #ffffff;
    box-shadow: 0px 1px 0.15rem 0px rgba(119, 119, 119, 0.2);
    border-radius: 0.25rem;
    border: 1px solid #eeeeee;
    font-size: 0.175rem;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 2.5rem;
    justify-content: center;

    p {
      width: 2rem;
      margin: 0 auto;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      text-align: center;
    }
  }

  .tui-makerImg {
    width: 0.65rem;
    height: 0.65rem;
    border-radius: 50%;
    display: flex;
    flex-shrink: 0;
    // position: absolute;
    // left: 0;
    background: red;
  }
}

.tui-desc {
  display: flex;
  align-items: center;
  padding-top: 0.125rem;

  div {
    font-size: 0.175rem;
    color: #999;
    padding-left: 0.0625rem;
  }

  img {
    width: 0.2rem;
    height: 0.2rem;
  }
}

.tui-list {
  display: flex;
  flex-direction: column;

  .tui-listItem {
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    margin-bottom: 0.25rem;
    padding-bottom: 0.25rem;
    cursor: pointer;

    .tui-listItemImg {
      width: 3.0125rem;
      height: 1.75rem;
      border-radius: 0.25rem;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .tui-listRight {
      padding-left: 0.4375rem;

      width: 100%;

      .tui-coolRight {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tui-coolTitle {
          font-size: 0.25rem;
          color: #333;
          font-weight: 600;
        }

        .tui-coolBtn {
          padding: 0 0.25rem;
          height: 0.5rem;
          background: #27abf7;
          border-radius: 0.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 0.2rem;
          cursor: pointer;
        }
      }
    }
  }
}

.tui-search {
  font-size: 0.2rem;
  color: #333;
  font-weight: 600;
}

.tui-placeType {
  display: flex;
  justify-content: space-between;
  padding: 0.375rem 0;

  .title {
    width: 1.25rem;
    font-size: 16px;
    color: #333;
    font-weight: 600;
    padding-right: 0.2rem;
    padding-bottom: 0.25rem;
    flex-shrink: 0;
  }

  .tui-placeTypeItem {
    width: 1.3625rem;
    height: 0.5rem;
    background: #f6f6f6;
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.2rem;
    color: #333;
    font-weight: 600;
    margin-right: 0.25rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
  }

  .tui-placeTypeItem:nth-of-type(10n) {
    margin-right: 0;
    // margin-bottom: 0;
  }

  .tui-placeTypeItemActive {
    background: rgba(39, 171, 247, 0.1) !important;
    color: #27abf7 !important;
  }
}

.tui-tabs {
  width: 3.2625rem;
  height: 0.5rem;
  background: #f6f6f6;
  border-radius: 0.25rem;
  color: #333;
  font-size: 0.2rem;
  display: flex;
  align-items: center;

  .tui-tabsItem {
    width: 1.7125rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.2rem;
  }

  .tui-active {
    background: #27abf7 !important;
    color: #fff !important;
  }
}
</style>